import { Injectable } from "@angular/core";
import { Http, Headers, URLSearchParams } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { Subject } from "rxjs/Subject";
import { GlobalProvider } from "./global";
import "rxjs/Rx";
import "rxjs/add/operator/map";

@Injectable()
export class EzoomApiProvider {
    //private apiUrl: string = "http://localhost:8080/api/";
    private apiUrl: string = "https://www.recreiodajuventude.com.br/api/";

    //private apiUrl: string = "http://localhost/api/";

    private apiUrlNew: string = "http://localhost:3000/";
    private apiToken: string = "EZRJ7392";
    private apiVersion: string = "2.6";
    private errorObserver: any;
    public error: any;

    constructor(public http: Http, public global: GlobalProvider) {
        this.errorObserver = null;
        this.error = Observable.create((observer) => {
            this.errorObserver = observer;
        });
    }

    public get(method: string, params: Object = {}, apiNew = false) {
        let ajaxObserver = new Subject();

        this._get(method, params, apiNew)
            .then((resolve) => {
                ajaxObserver.next(resolve);
                ajaxObserver.complete();
            })
            .catch((error) => {
                ajaxObserver.complete();
            });

        return ajaxObserver;
    }

    public post(method: string, params: Object = {}, apiNew = false) {
        let ajaxObserver = new Subject();

        this._post(method, params, apiNew)
            .then((resolve) => {
                ajaxObserver.next(resolve);
                ajaxObserver.complete();
            })
            .catch((error) => {
                ajaxObserver.complete();
            });

        return ajaxObserver;
    }

    public upload(method: string, data: any = {}, apiNew = false) {
        let ajaxObserver = new Subject();

        this._upload(method, data, apiNew)
            .then((resolve) => {
                ajaxObserver.next(resolve);
                ajaxObserver.complete();
            })
            .catch((error) => {
                ajaxObserver.complete();
            });

        return ajaxObserver;
    }

    private async _get(
        method: string,
        params: Object = {},
        apiNew
    ): Promise<JSON> {
        try {
            let query: URLSearchParams = this.buildParams(params);
            let headers = await this.getHeaders();
            const response = await this.http
                .get(
                    (this.apiUrlNew && apiNew ? this.apiUrlNew : this.apiUrl) +
                        method,
                    { headers: headers, search: query }
                )
                .toPromise();
            return response.json();
        } catch (error) {
            await this.handleError(error, method);
        }
    }

    private async _post(
        method: string,
        params: Object = {},
        apiNew
    ): Promise<JSON> {
        try {
            let query: URLSearchParams = this.buildParams(params);
            let headers = await this.getHeaders();
            console.log(query);
            const response = await this.http
                .post(
                    this.apiUrlNew && apiNew
                        ? this.apiUrlNew
                        : this.apiUrl + method,
                    query,
                    { headers: headers }
                )
                .toPromise();
            return response.json();
        } catch (error) {
            await this.handleError(error, method);
        }
    }

    private async _upload(method: string, data: any, apiNew): Promise<JSON> {
        try {
            let headers = await this.getHeaders();
            headers.delete("Content-Type");
            const response = await this.http
                .post(
                    this.apiUrlNew && apiNew
                        ? this.apiUrlNew
                        : this.apiUrl + method,
                    data,
                    { headers: headers }
                )
                .toPromise();
            return response.json();
        } catch (error) {
            await this.handleError(error, method);
        }
    }

    private async getHeaders() {
        let headers = new Headers();
        headers.append(
            "Content-Type",
            "application/x-www-form-urlencoded; charset=UTF-8"
        );
        headers.append("api-token", this.apiToken);
        headers.append("api-version", this.apiVersion);
        headers.append("Accept", "application/json");
        headers.append("app-version", "web");
        
        await this.global.getSessionId().then((sessionId: any) => {
            if (sessionId !== false) {
                headers.append("session-id", sessionId);
            }
        });

        return await headers;
    }

    private handleError(error, method) {
        error.method = method;
        this.errorObserver.next(error);
        return Observable.throw(error);
    }

    private buildParams(params: any) {
        let query: URLSearchParams = new URLSearchParams();
        Object.keys(params).forEach((key) => {
            if (params[key] && typeof params[key] == "object") {
                if (params[key] instanceof Array) {
                    let i = 0;
                    params[key].forEach((item) => {
                        if (typeof item == "object") {
                            Object.keys(item).forEach((keyIn) => {
                                query.set(
                                    key + "[" + i + "][" + keyIn + "]",
                                    item[keyIn]
                                );
                            });
                        } else {
                            query.set(key + "[" + i + "]", item);
                        }
                        i++;
                    });
                } else {
                    Object.keys(params[key]).forEach((keyIn) => {
                        query.set(key + "[" + keyIn + "]", params[key][keyIn]);
                    });
                }
            } else {
                query.set(key, params[key]);
            }
        });
        return query;
    }
}



// WEBPACK FOOTER //
// ./src/providers/ezoom-api.ts